<div class="scrollable-wrapper">
  <div class="company-cbp-connection-container">
    <div class="title mb-2">
      {{ "PAGE.ON_BOARDING.TITLE" | translate }}
    </div>
    <div class="description" *ngIf="company" [innerHTML]="'PAGE.ON_BOARDING.DESC' | translate"></div>
    <div class="description" *ngIf="!company">
      {{ "PAGE.ON_BOARDING.DESC_WITHOUT_COMPANY" | translate }}
      <a [routerLink]="['/companies', 'account-settings', 'create']">{{ "PAGE.ON_BOARDING.CREATE_COMPANY" | translate }}</a>
    </div>

    <div *ngIf="cbpConnectionsInfo">
      <self-filer-code-form
        *ngIf="company"
        [filerCodeInfo]="cbpConnectionsInfo.filerCodeDetails"
        [companyId]="company.id"
        [additionalPorts]="cbpConnectionsInfo.allowedPorts"
        (update)="updateCompany()"
        (updateABI)="updateAbiTransmitter($event)"
      ></self-filer-code-form>
      <self-filer-abi-profile-form
        *ngIf="company"
        [abiProfileDetails]="cbpConnectionsInfo.abiProfileDetails"
        [companyId]="company.id"
        [hasFilerCode]="hasFilerCode"
        (update)="updateCompany()"
      ></self-filer-abi-profile-form>
      <self-filer-ach-debit-form
        *ngIf="company"
        [achMethodDetails]="cbpConnectionsInfo.achMethodDetails"
        [companyId]="company.id"
        [companyAuthorizationAgreementAccepted]="company.authorizationAgreementAccepted"
        [hasFilerCode]="hasFilerCode"
        (update)="updateCompany()"
      ></self-filer-ach-debit-form>
    </div>
  </div>
</div>
